var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Payment cancelled!")]),_c('p',[_vm._v(" Oops, something went wrong during the payment. Please try again. ")])])}]

export { render, staticRenderFns }